import { IconName } from 'components/_core/Icon';
import { IconName as SunshineIconName } from 'components/_core/SunshineIcon';

export const getRebrandedIconName = (icon: IconName): SunshineIconName => {
  switch (icon) {
    case 'bank':
      return 'wallet';
    case 'payment':
      return 'transfer';
    case 'credit-card-recto':
      return 'card-recto';
    case 'toolbox':
      return 'toolbox';
    case 'user-list':
      return 'avatar-list';
    case 'umbrella':
      return 'insurance';
    case 'receipt':
      return 'receipt';
    case 'team':
      return 'team';
    case 'star':
      return 'star';
    case 'user-star':
      return 'star';
    case 'pie-chart':
      return 'contribution';
    case 'info':
      return 'information';
    default:
      return 'card-recto';
  }
};
